// @flow

import {
  type UserInputValidationError,
  type UserInputValidatorArgs,
  onlyWhenSupport,
  VALID,
} from '@tectonics/prs/validation';

import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { getCurrentPaymentMethodOptionalFields, hasOptionalField } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

import { validateZambiaPhoneNumber } from './zambia-phone-number';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);
  let optionalFields = incomingPayment.status === 'OP' ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec) : [];

  switch (userInputName) {
    case 'zambiaPhoneNumber':
      if (!hasOptionalField(optionalFields, 'telephone')) {
        return onlyWhen('field_zambia_phone_number') && validateZambiaPhoneNumber(userInputValue);
      }
      return null;

    default:
      return VALID;
  }
}
